import { type CalendarLoading } from '../MonthCalendarGrid/types'

type MonthLoadingParams = {
  /** Whether an answer for some window is already drawn. */
  hasWindow: boolean
  isFetching: boolean
}

/**
 * Which loading treatment the month window's query state has earned.
 *
 * What decides it is whether there is anything on screen, not how long the
 * fetch has run. A month a person can already read is refreshed under a
 * hairline; only a month nobody has seen yet is filled with placeholders.
 */
export const monthLoadingState = ({
  hasWindow,
  isFetching,
}: MonthLoadingParams): CalendarLoading => {
  if (!isFetching) return 'idle'
  return hasWindow ? 'refetching' : 'initial'
}
